import React from "react";
import VisualizationLoader from "./VisualizationLoader";

const VisualizationLoadingHandler = ({
  isLoading,
  Component
}: {
  isLoading: boolean;
  Component: JSX.Element;
}) => (isLoading ? <VisualizationLoader /> : Component);

export default VisualizationLoadingHandler;
